/* eslint-disable react/no-did-update-set-state */
/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Field, Form, withFormik } from "formik";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as debinSelectors, actions as debinActions } from "reducers/debin";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import Col from "react-bootstrap/lib/Col";
import TextField from "pages/_components/fields/TextField";
import Selector from "pages/_components/fields/formik/Selector";
import * as i18n from "util/i18n";
import { DateField } from "pages/_components/fields/DateField";
import RangeDatePicker from "pages/_components/fields/rangedatepicker/RangeDatePicker";
import PageLoading from "pages/_components/PageLoading";
import DebinRequestsList from "pages/charges/_components/DebinRequestsList";
import { func, shape, bool, string } from "prop-types";
import { push } from "react-router-redux/actions";
import Notification from "pages/_components/Notification";
import moment from "moment";
import { allStatus } from "util/debin";
import ContextMenu from "pages/_components/ContextMenu";
import Yup from "yup";
import * as configUtils from "util/config";
import { actions as statusActions } from "reducers/status";
import { isIOS } from "react-device-detect";
import { evalEqualsValues } from "util/form";
import classNames from "classnames";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

const FORM_ID = "charges.debin.sentRequests";

class DebinRequests extends Component {
    state = {
        selectedDateFrom: null,
        selectedDateTo: null,
        showForm: false,
        hasChanged: false,
    };

    enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

    static propTypes = {
        activeEnvironment: shape({
            permissions: shape({
                addRemoveDebinAccount: bool,
            }),
        }).isRequired,
        dateFrom: shape({}).isRequired,
        dateTo: shape({}).isRequired,
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        filtersSentRequests: shape({
            dateFrom: shape({}).isRequired,
            dateTo: shape({}).isRequired,
            status: string.isRequired,
            recipient: string.isRequired,
        }).isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        setFieldValue: func.isRequired,
        values: shape({}).isRequired,
        location: shape({}).isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch, setFieldValue, values, filtersSentRequests, location } = this.props;
        const dateFrom =
            filtersSentRequests.dateFrom ||
            moment()
                .add(-1, "weeks")
                .toDate();
        const dateTo = filtersSentRequests.dateTo || moment().toDate();
        const status = filtersSentRequests.status || values.status;
        const { recipient } = filtersSentRequests;
        this.setState({ selectedDateFrom: dateFrom });
        this.setState({ selectedDateTo: dateTo });
        if (this.enableRangeDatefield) {
            setFieldValue("dates", [dateFrom, dateTo]);
        } else {
            setFieldValue("dateFrom", dateFrom);
            setFieldValue("dateTo", dateTo);
        }
        setFieldValue("status", status);
        setFieldValue("recipient", recipient);
        setTimeout(() => {
            this.handleFilterButton();
        }, 500);
        dispatch(debinActions.loadSentRequests({ dateFrom, dateTo, pageNumber: 1, status, recipient }));
        dispatch(debinActions.cleanIsBackFromSummary());
        dispatch(statusActions.saveLastHref(location));
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, activeEnvironment } = this.props;
        const { embeddedInV3Shell: prevEmbedded, isDesktop: prevDesktop, activeEnvironment: prevEnv } = prevProps;
        if (prevEmbedded !== embeddedInV3Shell || prevDesktop !== isDesktop || prevEnv !== activeEnvironment) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            titleKey: "charges.debin.sentRequests.title",
            goBackPath: "/v3/dashboard",
            scopes: ["debin"],
            rightContentMobile: embeddedInV3Shell && !isDesktop ? this.rightContent() : undefined,
        });
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        dispatch(push(embeddedInV3Shell ? "/v3/dashboard" : "/desktop"));
    };

    rightContent = () => {
        const { dispatch, isDesktop, activeEnvironment } = this.props;

        if (isDesktop) {
            return (
                <div className="d-flex gap-2">
                    <Button
                        block
                        onClick={() => dispatch(push("/charges/requestDebin"))}
                        label="charges.debin.sentRequests.button"
                        bsStyle="primary"
                        className="cmf-button-width"
                    />
                    {activeEnvironment.permissions.addRemoveDebinAccount ? (
                        <Button
                            className="btn-outline cmf-button-width"
                            block
                            onClick={() => dispatch(push("debin/addAccounts"))}
                            label="charges.debin.addAccounts.button"
                        />
                    ) : (
                        undefined
                    )}
                </div>
            );
        }

        const actions = [
            {
                label: "charges.debin.sentRequests.button",
                onClick: () => dispatch(push("/charges/requestDebin")),
                icon: "RequestDebin",
            },
        ];
        if (activeEnvironment.permissions.addRemoveDebinAccount) {
            actions.push({
                label: "charges.debin.addAccounts.button",
                onClick: () => dispatch(push("debin/addAccounts")),
                icon: "AddAccount",
            });
        }

        return (
            <ContextMenu
                isDesktop={isDesktop}
                color="white"
                buttonClassName={`align-self-center account-dropdown-header-font ${
                    !isDesktop ? "font-black-alpha" : ""
                }`}
                items={actions}
            />
        );
    };

    renderEmptyState = () => {};

    handleChangeDateFrom = (selectedDate) => {
        this.setState({ selectedDateFrom: selectedDate });
    };

    handleChangeDateTo = (selectedDate) => {
        this.setState({ selectedDateTo: selectedDate });
    };

    centerContentMobile = () => (
        <div>
            <h1 className="m-0">{i18n.get("charges.debin.sentRequests.title")}</h1>
        </div>
    );

    cleanFilters = () => {
        const { setFieldValue, dispatch } = this.props;

        const defaultFilters = {
            status: "Todos",
            recipient: "",
            dateFrom: moment()
                .add(-1, "weeks")
                .toDate(),
            dateTo: moment().toDate(),
        };
        setFieldValue("status", defaultFilters.status);
        setFieldValue("recipient", defaultFilters.recipient);
        if (this.enableRangeDatefield) {
            setFieldValue("dates", [defaultFilters.dateFrom, defaultFilters.dateTo]);
        } else {
            setFieldValue("dateFrom", defaultFilters.dateFrom);
            setFieldValue("dateTo", defaultFilters.dateTo);
        }

        dispatch(debinActions.loadSentRequests({ ...defaultFilters, pageNumber: 1 }));
        this.setState((prevState) => ({ ...prevState, hasChanged: false }));
    };

    isDateChanged = (date1, date2) => {
        const dateOne = date1 && date1 instanceof moment ? date1.toDate() : date1;
        const dateTwo = date2 && date2 instanceof moment ? date2.toDate() : date2;
        return dateOne?.toDateString() !== dateTwo?.toDateString();
    };

    handleFilterButton = () => {
        const { values } = this.props;
        const { status, recipient, dateFrom, dateTo, dates } = values;

        const dateFromChanged = this.isDateChanged(
            this.enableRangeDatefield ? dates[0] : dateFrom,
            moment()
                .add(-1, "weeks")
                .toDate(),
        );
        const dateToChanged = this.isDateChanged(this.enableRangeDatefield ? dates[1] : dateTo, moment().toDate());
        if (status !== "Todos" || recipient || dateFromChanged || dateToChanged) {
            this.setState((prevState) => ({ ...prevState, hasChanged: true }));
        } else {
            this.setState((prevState) => ({ ...prevState, hasChanged: false }));
        }
    };

    render() {
        const { values, fetching, isDesktop, isSmallDesktop, filtersSentRequests, embeddedInV3Shell } = this.props;
        const { dateFrom, dateTo, dates } = values;
        const { selectedDateFrom, selectedDateTo, showForm, hasChanged } = this.state;
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        const defaultOptionState = { value: "Todos", label: "TODOS" };
        const getLgCols = (a, b, c, type) => {
            if (this.enableRangeDatefield) {
                if (type === "status") {
                    return a;
                }
                if (isSmallDesktop) {
                    return a;
                }
                return b;
            }
            if (type === "status") {
                if (isSmallDesktop) {
                    return b;
                }
            }
            return c;
        };
        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="debin" />}
                <div className="admin-detail-head px-0">
                    {isDesktop && <Head onBack={this.handleBack} />}
                    {!(embeddedInV3Shell && !isDesktop) && (
                        <Head
                            title={isDesktop ? "charges.debin.sentRequests.title" : null}
                            rightContent={this.rightContent}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={!isDesktop && this.centerContentMobile}
                            centerContentClassName={!isDesktop ? "mx-5 align-center" : "p-0"}
                            onBack={!isDesktop && this.handleBack}
                        />
                    )}
                </div>
                <div className="above-the-fold">
                    <Form autocomplete="off" className="above-the-fold">
                        {isDesktop && (
                            <Container>
                                <Col className="hide-filter__btn-content mt-5 mb-3">
                                    <Button
                                        block
                                        bsStyle="outline"
                                        className="hide-filter__btn m-0"
                                        label={
                                            showForm
                                                ? "global.hide.filter"
                                                : `${hasChanged ? "global.filter.active" : "global.see.filter"}`
                                        }
                                        image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                        onClick={() => this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))}
                                    />
                                    {hasChanged && (
                                        <Button
                                            label="echeq.clean.filters"
                                            className="hide-filter__clean-btn"
                                            onClick={() => this.cleanFilters()}
                                            image="images/cross.svg"
                                            imageStyle="circle-cross"
                                        />
                                    )}
                                </Col>
                            </Container>
                        )}
                        {!isDesktop && (
                            <Col xs={12} className="d-flex justify-content-end pr-0 py-3">
                                <div className="hide-filter__btn-content">
                                    <Button
                                        block
                                        bsStyle="outline"
                                        className="hide-filter__btn m-0"
                                        label={
                                            showForm
                                                ? "global.hide.filter"
                                                : `${hasChanged ? "global.filter.active" : "global.see.filter"}`
                                        }
                                        image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                        onClick={() => this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))}
                                    />
                                </div>
                                {hasChanged && (
                                    <Button
                                        label="global.clean.filters"
                                        className="clean-filters-label font-light p-absolute top-25 mt-2 pt-1 min-height-auto mr-4 "
                                        onClick={() => this.cleanFilters()}
                                        image="images/cross.svg"
                                        imageStyle="circle-cross"
                                    />
                                )}
                            </Col>
                        )}
                        {showForm && !fetching && (
                            <Container
                                className={`flex-grow mt-4 ${
                                    isDesktop ? "container-white pt-3 mb-0 pb-0 px-2" : "px-2"
                                }`}
                                gridClassName="form-content"
                                rowClassName={`${isIOS && "w-100 m-0"}`}>
                                <Col xs={12} md={4} lg={getLgCols(3, 4, 3, "recipient")}>
                                    <Field
                                        component={TextField}
                                        idForm={FORM_ID}
                                        name="recipient"
                                        type="text"
                                        pattern="[0-9]*"
                                        maxLength={configUtils.get("cuit.validation.character.amount")}
                                        minLength={0}
                                        formGroupClassName="ellipsis-span"
                                    />
                                </Col>
                                <Col xs={12} md={4} lg={getLgCols(3, 3, 2, "status")}>
                                    <Field
                                        component={Selector}
                                        options={[defaultOptionState, ...allStatus]}
                                        idForm={FORM_ID}
                                        name="status"
                                        isRequired
                                        value={values?.status || defaultOptionState}
                                        searchable={isDesktop}
                                    />
                                </Col>
                                {this.enableRangeDatefield ? (
                                    <Col xs={12} md={6} lg={isSmallDesktop ? 4 : 3} className="mt-1">
                                        <Field
                                            component={RangeDatePicker}
                                            idForm={FORM_ID}
                                            name="dates"
                                            required
                                            maxDate={new Date()}
                                            value={dates}
                                            className="height-48"
                                        />
                                    </Col>
                                ) : (
                                    <>
                                        <Col xs={12} md={4} lg={2}>
                                            <Field
                                                idField="dateFrom"
                                                component={DateField}
                                                idForm={FORM_ID}
                                                name="dateFrom"
                                                hidePlaceholder
                                                endDate={dateTo}
                                                startDate={dateFrom}
                                                maxDate={selectedDateTo}
                                                handleChange={this.handleChangeDateFrom}
                                                selectsStart
                                            />
                                        </Col>
                                        <Col xs={12} md={4} lg={2}>
                                            <Field
                                                idField="dateTo"
                                                component={DateField}
                                                idForm={FORM_ID}
                                                name="dateTo"
                                                hidePlaceholder
                                                minDate={selectedDateFrom}
                                                handleChange={this.handleChangeDateTo}
                                                selectsEnd
                                                maxDate={new Date()}
                                                endDate={dateTo}
                                                startDate={dateFrom}
                                            />
                                        </Col>
                                    </>
                                )}

                                <Col xs={12} md={4} lg={2}>
                                    <div className="form-group mt-4">
                                        <Button
                                            label={
                                                enableNewSubmitButton
                                                    ? "global.filter"
                                                    : "fixedTermAcceptance.list.button.search"
                                            }
                                            bsStyle="primary"
                                            type="submit"
                                            className={classNames("filter-button mt-25 py-25", {
                                                "text-transform-none": enableNewSubmitButton,
                                            })}
                                            loading={fetching}
                                            onClick={() => this.handleFilterButton()}
                                            image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                                            imageStyle="mr-2"
                                            disabled={
                                                enableNewSubmitButton &&
                                                evalEqualsValues(filtersSentRequests, values, undefined, [
                                                    ...(this.enableRangeDatefield ? ["dates"] : []),
                                                    ...(!this.enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                                ])
                                            }
                                        />
                                    </div>
                                </Col>
                            </Container>
                        )}
                        <PageLoading className="line-loader" loading={fetching}>
                            <DebinRequestsList itemsAreClickeable isDesktop={isDesktop} />
                        </PageLoading>
                    </Form>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: sessionSelectors.getUser(state),
    sentRequests: debinSelectors.getSentRequests(state),
    fetching: debinSelectors.getFetching(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    filtersSentRequests: debinSelectors.getFiltersSentRequests(state),
});

export default compose(
    connect(mapStateToProps),
    resizableRoute,
    withFormik({
        mapPropsToValues: () => ({
            recipient: "",
            status: "Todos",
        }),
        validationSchema: () => {
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            return Yup.object().shape({
                recipient: Yup.string()
                    .nullable()
                    .min(configUtils.get("cuit.validation.character.amount"), i18n.get(`${FORM_ID}.recipient.invalid`))
                    .max(configUtils.get("cuit.validation.character.amount"), i18n.get(`${FORM_ID}.recipient.invalid`)),
                ...(enableRangeDatefield
                    ? {
                          dates: Yup.mixed().test(
                              "dates",
                              i18n.get(`${FORM_ID}.validation.range.date`),
                              ([from, to]) => from && to,
                          ),
                      }
                    : {
                          dateTo: Yup.string()
                              .nullable()
                              .required(i18n.get(`${FORM_ID}.field.error.required`)),
                          dateFrom: Yup.string()
                              .nullable()
                              .required(i18n.get(`${FORM_ID}.field.error.required`)),
                      }),
            });
        },
        handleSubmit: (filters, formikBag) => {
            const { dispatch } = formikBag.props;
            const { recipient, dates, ...filtersRest } = filters;
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

            dispatch(
                debinActions.loadSentRequests({
                    ...filtersRest,
                    ...(enableRangeDatefield && { dateFrom: dates[0], dateTo: dates[1] }),
                    recipientType: recipient ? "comprador" : null,
                    recipient,
                    pageNumber: 1,
                }),
            );
        },
    }),
)(DebinRequests);
